import { render, staticRenderFns } from "./Devolver.vue?vue&type=template&id=a4fbb37e"
import script from "./Devolver.vue?vue&type=script&lang=js"
export * from "./Devolver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports